import { render } from "./shareApply.vue?vue&type=template&id=f9b40840&scoped=true"
import script from "./shareApply.vue?vue&type=script&lang=js"
export * from "./shareApply.vue?vue&type=script&lang=js"

import "./shareApply.vue?vue&type=style&index=0&id=f9b40840&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9b40840"]])

export default __exports__